import React from 'react';
import { SelectionType } from '../../enums/SelectionType.enum';
import { ProductControls } from '../../components/ProductControls';
import styles from './ShopNowFloatingButton.module.scss';
import { Button } from './buttons/Button';

interface ShopNowButtonProps {
  showAddToBag?: boolean;
  scrollToProductSection?: () => void;
}

export const ShopNowFloatingButton: React.FC<ShopNowButtonProps> = ({ showAddToBag, scrollToProductSection }) => {
  document.body.classList.add('bottom-bar');
  return (
    <div className={styles.bottomBar}>
      {showAddToBag ? (
        <ProductControls selectionType={SelectionType.ProductSection} selectionKey="0" simplified={true} />
      ) : (
        <Button text="Shop Now" onClick={scrollToProductSection} buttonType="primary" />
      )}
    </div>
  );
};

export default ShopNowFloatingButton;
